import AdGenIcon from '@svgIcons/nb/ad_gen.svg';
import AiAgentIcon from '@svgIcons/nb/ai_agent.svg';
import AutomationIcon from '@svgIcons/nb/automation.svg';
import CampaignIcon from '@svgIcons/nb/campaign.svg';
import ConnectionIcon from '@svgIcons/nb/connection.svg';
import CustomerJourneyIcon from '@svgIcons/nb/customer_journey.svg';
import DashboardIcon from '@svgIcons/nb/dashboard.svg';
import DataStreamIcon from '@svgIcons/nb/data_stream.svg';
import GuideIcon from '@svgIcons/nb/guide.svg';
import SettingIcon from '@svgIcons/nb/setting.svg';
import SpendRulesIcon from '@svgIcons/nb/spend_rules.svg';
// currentColor, so it needs no _on twin — the menu wrapper sets the color.
import TeamspaceIcon from '@svgIcons/nb/teamspace.svg';

import ActiveAdGenIcon from '@svgIcons/nb/ad_gen_on.svg';
import ActiveAiAgentIcon from '@svgIcons/nb/ai_agent_on.svg';
import ActiveAutomationIcon from '@svgIcons/nb/automation_on.svg';
import ActiveCampaignIcon from '@svgIcons/nb/campaign_on.svg';
import ActiveConnectionIcon from '@svgIcons/nb/connection_on.svg';
import ActiveCustomerJourneyIcon from '@svgIcons/nb/customer_journey_on.svg';
import ActiveDashboardIcon from '@svgIcons/nb/dashboard_on.svg';
import ActiveDataStreamIcon from '@svgIcons/nb/data_stream_on.svg';
import ActiveGuideIcon from '@svgIcons/nb/guide_on.svg';
import ActiveSettingIcon from '@svgIcons/nb/setting_on.svg';
import ActiveSpendRulesIcon from '@svgIcons/nb/spend_rules_on.svg';

export const MENU_TYPES = {
    ad_gen: 'ad_gen',
    ai_agent: 'ai_agent',
    automation: 'automation',
    campaign: 'campaign',
    connection: 'connection',
    customer_journey: 'customer_journey',
    dashboard: 'dashboard',
    data_stream: 'data_stream',
    guide: 'guide',
    setting: 'setting',
    spend_rules: 'spend_rules',
    teamspace: 'teamspace',
};

export const Routes = {
    [MENU_TYPES.ad_gen]: 'https://app.adgenai.com',
    [MENU_TYPES.ai_agent]: '/agent/chat',
    [MENU_TYPES.automation]: '/dashboard/customizable/alarms',
    [MENU_TYPES.campaign]: '/myCampaigns',
    [MENU_TYPES.connection]: '/connection',
    [MENU_TYPES.customer_journey]: '/customerJourney',
    [MENU_TYPES.dashboard]: '/dashboard',
    [MENU_TYPES.data_stream]: '/dataTransfer',
    [MENU_TYPES.setting]: '/settings',
    [MENU_TYPES.spend_rules]: '/margin-management',
    [MENU_TYPES.teamspace]: '/teamspaces',
};

const AD_GEN = {
    type: MENU_TYPES.ad_gen,
    openNew: true,
    to: Routes[MENU_TYPES.ad_gen],
    icon: AdGenIcon,
    activeIcon: ActiveAdGenIcon,
    position: 'top',
};
const AI_AGENT = {
    type: MENU_TYPES.ai_agent,
    to: Routes[MENU_TYPES.ai_agent],
    icon: AiAgentIcon,
    activeIcon: ActiveAiAgentIcon,
    position: 'top',
    beta: true,
};
const AUTOMATION = {
    type: MENU_TYPES.automation,
    to: Routes[MENU_TYPES.automation],
    icon: AutomationIcon,
    activeIcon: ActiveAutomationIcon,
    position: 'top',
};
const CAMPAIGN = {
    type: MENU_TYPES.campaign,
    to: Routes[MENU_TYPES.campaign],
    icon: CampaignIcon,
    activeIcon: ActiveCampaignIcon,
    position: 'top',
    nested: ['/proposal'],
};
const CONNETION = {
    type: MENU_TYPES.connection,
    to: Routes[MENU_TYPES.connection],
    icon: ConnectionIcon,
    activeIcon: ActiveConnectionIcon,
    position: 'top',
};
const CUSTOMER_JOURNEY = {
    type: MENU_TYPES.customer_journey,
    to: Routes[MENU_TYPES.customer_journey],
    icon: CustomerJourneyIcon,
    activeIcon: ActiveCustomerJourneyIcon,
    position: 'top',
};
const DASHBOARD = {
    type: MENU_TYPES.dashboard,
    to: Routes[MENU_TYPES.dashboard],
    icon: DashboardIcon,
    activeIcon: ActiveDashboardIcon,
    position: 'top',
};
export const DATA_STREAM = {
    type: MENU_TYPES.data_stream,
    to: Routes[MENU_TYPES.data_stream],
    icon: DataStreamIcon,
    activeIcon: ActiveDataStreamIcon,
    position: 'top',
};
const GUIDE = {
    type: MENU_TYPES.guide,
    openNew: true,
    icon: GuideIcon,
    activeIcon: ActiveGuideIcon,
    position: 'bottom',
};
const SETTING = {
    type: MENU_TYPES.setting,
    to: Routes[MENU_TYPES.setting],
    icon: SettingIcon,
    activeIcon: ActiveSettingIcon,
    position: 'bottom',
    nested: ['/billingHistory', '/custom-exchange-rate'],
};
const SPEND_RULES = {
    type: MENU_TYPES.spend_rules,
    to: Routes[MENU_TYPES.spend_rules],
    icon: SpendRulesIcon,
    activeIcon: ActiveSpendRulesIcon,
    position: 'top',
};
const TEAMSPACE = {
    type: MENU_TYPES.teamspace,
    to: Routes[MENU_TYPES.teamspace],
    icon: TeamspaceIcon,
    activeIcon: TeamspaceIcon,
    position: 'bottom',
};

export const PLAN_A_MENUS = [
    CONNETION,
    DASHBOARD,
    DATA_STREAM,
    CAMPAIGN,
    AUTOMATION,
    AI_AGENT,
    CUSTOMER_JOURNEY,
    SPEND_RULES,
    // AD_GEN,
    GUIDE,
    TEAMSPACE,
    SETTING,
];
export const PLAN_T_MENUS = [
    CONNETION,
    DASHBOARD,
    DATA_STREAM,
    AUTOMATION,
    AI_AGENT,
    CUSTOMER_JOURNEY,
    SPEND_RULES,
    // AD_GEN,
    GUIDE,
    TEAMSPACE,
    SETTING,
];
